class QuickAddVariants extends HTMLElement {
  constructor() {
    super();
    
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  }

  connectedCallback() {
    const productId = this.getAttribute('data-product-id');
    const productVariants = JSON.parse(document.getElementById(`QuickAddVariants-${productId}`).textContent);
    this.renderOptions(productVariants);

    const openButton = this.querySelector('#quick-add-variants-open-button');
    openButton.addEventListener('click', () => {
      this.classList.toggle('show-quick-add-variants');
    });

    this.addEventListener('click', (event) => {
      const variantButton = event.target.closest('.variant-option');
      this.addToCart(variantButton.dataset.variantId);
    });
  }

  renderOptions(variants) {
    const optionsContainer = document.createElement('div');
    optionsContainer.classList.add('variant-options');

    variants.forEach((variant) => {
      const option = document.createElement('button');
      option.classList.add('variant-option');
      option.classList.add(`available-${variant.available}`);

      // Extract the number from the variant title
      const numberMatch = variant.title.match(/(\d+(\.\d+)?)/);

      const optionValue = document.createElement('span');
      optionValue.classList.add('variant-option-value');
      optionValue.textContent = numberMatch ? numberMatch[0] : variant.title;
      option.appendChild(optionValue);


      if (!variant.available) {
        const svgHtml = `
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-mail">
            <path
              d="M0.833252 8.33335V1.66669H9.16658V8.33335H0.833252ZM4.99992 5.41669L1.66659 3.33335V7.50002H8.33325V3.33335L4.99992 5.41669ZM4.99992 4.58335L8.33325 2.50002H1.66659L4.99992 4.58335ZM1.66659 3.33335V2.50002V7.50002V3.33335Z"
              fill="currentColor" />
          </svg>
        `;

        option.insertAdjacentHTML('beforeend', svgHtml);
      }

      // option.textContent = variant.option1.replace('Womens ', '').replace('Mens ', '');
      option.dataset.variantId = variant.id;
      optionsContainer.appendChild(option);
    });

    this.innerHTML = `
      <div class="quick-add-variants-header">
        <h4 class="body-copy-small" id="quick-add-variants-title">Quick Add +</h4>
        <button id="quick-add-variants-open-button" class="link"><span class="body-copy-small">Quick Add</span></button>
      </div>
      ${optionsContainer.outerHTML}
    `;
  }

  addToCart(variantId) {

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;


    console.log('Adding variant:', variantId);
    if (!variantId) {
      console.error('No variant selected');
      return;
    }

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        console.log('Added to cart:', response);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'custom-collection-quick-add',
          cartData: response,
        });
        this.cart.renderContents(response);
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }
}

customElements.define('quick-add-variants', QuickAddVariants);
